// This file is generated by Sapper — do not edit it!
// webpack does not support export * as root_comp yet so do a two line import/export
import * as root_comp from '../../../routes/_layout.svelte';
export { root_comp };
export { default as ErrorComponent } from '../../../routes/_error.svelte';

export const ignore = [/^\/guide\/([^/]+?)\.json$/, /^\/api\/example-data\.json$/];

export const components = [
	{
		js: () => import("../../../routes/index.svelte")
	},
	{
		js: () => import("../../../routes/guide/index.svelte")
	},
	{
		js: () => import("../../../routes/guide/[lang]/index.svelte")
	},
	{
		js: () => import("../../../routes/repl/index.svelte")
	}
];

export const routes = (d => [
	{
		// index.svelte
		pattern: /^\/$/,
		parts: [
			{ i: 0 }
		]
	},

	{
		// guide/index.svelte
		pattern: /^\/guide\/?$/,
		parts: [
			{ i: 1 }
		]
	},

	{
		// guide/[lang]/index.svelte
		pattern: /^\/guide\/([^/]+?)\/?$/,
		parts: [
			null,
			{ i: 2, params: match => ({ lang: d(match[1]) }) }
		]
	},

	{
		// repl/index.svelte
		pattern: /^\/repl\/?$/,
		parts: [
			{ i: 3 }
		]
	}
])(decodeURIComponent);